import getQrCodeService from "@/services/QrCodeService";
import mutationTypes from "./mutation-types";

const load = async ({ commit, dispatch }, id) => {
    const qrcodeService = getQrCodeService();

    try {
        const qrcodeObject = await qrcodeService.loadQrCode(id);
        const videoUrl = await getQrCodeService().computeVideoUrl(qrcodeObject);
        const { html, scripts } = getQrCodeService().computeCustomHtmlContent(qrcodeObject);

        // initialize qrCode asset if not burned qrCode
        if (qrcodeObject.isOpen) {
            getQrCodeService().setExperienceAssets(qrcodeObject, videoUrl);
        }

        if (qrcodeObject.accountRequired === "NO_ACCOUNT") {
            dispatch("auth/logout", { keepStorage: true }, { root: true });
        }

        commit(mutationTypes.SET_QRCODE_OBJECT, qrcodeObject);
        commit(mutationTypes.SET_VIDEO_URL, videoUrl);
        commit(mutationTypes.SET_CUSTOM_HTML, html);
        commit(mutationTypes.SET_CUSTOM_JS, scripts);
    } catch (e) {
        let title = "";
        let text = "";
        switch (e.response?.data?.code) {
            case "EBADREQUEST":
                title = "errors.qrcodeNotFoundTitle";
                text = "errors.qrcodeNotFoundText";
                break;

            default:
                title = "errors.serverErrorTitle";
                text = "errors.serverErrorText";
        }

        dispatch("displayError", { title, text });
    }
};

const logScan = async (_, id) => {
    await getQrCodeService().logScan(id);
};

const displayError = ({ commit }, { title, text }) => {
    commit(mutationTypes.RAISE_QRCODE_ERROR, { title, text });
};

const clearError = ({ commit }) => {
    commit(mutationTypes.CLEAR_ERROR);
};

export default {
    load,
    logScan,
    clearError,
    displayError
};
